import styled from 'styled-components';
import { Conditions } from 'next/components/Conditions';

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${Conditions}:last-child {
    margin-bottom: 16px;
  }
`;

export const SectionTitle = styled.span`
  font-weight: var(--bold);
  color: var(--heading-primary);
`;

export const HelpText = styled.p`
  color: var(--sharkbait-ooh-la-la);
`;

export const Targeting = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 16px 0 0 24px;
`;

export const HelpTextEmphasis = styled.span`
  color: var(--gradient-green);
  font-weight: var(--bold);
`;
